firebird.factory('videoSizeService', [
    '$window',
    'logService',
    'configService',
    'videoGlobalService',
    'helperService',
    'executionEnvironmentEnum',
    function ($window, logService, configService, videoGlobalService, helperService, executionEnvironmentEnum) {
        var service = {
            initialize: initialize,
            getVideoResolution: getVideoResolution
        };

        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.initVideoSize = initVideoSize;

            // Aspect ratio, width and height
            self.idealAspectRatio = 16 / 9;
            self.minAspectRatio = 1;
            self.idealVideoWidth = 1280;
            self.idealVideoHeight = 720;
            self.maxScreenWidth = 1920;
            self.maxScreenHeight = 1080;
            self.maxFileWidth = 1280;
            self.maxFileHeight = 720;

            // video capture resolution (hires-16:9 is 1280x720 default):
            // allowed values are: hires-16:9, stdres-16:9, stdres, lowres-16:9, lowres.
            self.videoResolution = null;

            // Max resolution for screen share. It uses 1920x1080 by default.
            // Can change using URL param. A special value of "native" allows using native resolution.
            self.videoResolutionScreen = null;

            // Max resolution for file play. It uses 1280x720 by default.
            // Can change using URL param. A special value of "native" allows using native resolution.
            self.videoResolutionFile = null;

            self.getVideoResolution = getVideoResolution;

            self.recalculateVideoOrientation = recalculateVideoOrientation;
            self.onVideoResize = onVideoResize;
            self.onVideoOrientationChange = onVideoOrientationChange;

            // whether to limit the max videos size. if set to true, then default value is [1440, 1080]
            self.maxVideosSize = null;
            self.initMaxVideosSize = initMaxVideosSize;

            self.enablePortraitRecord = false;
        }

        // update from config
        function initVideoSize() {
            // video resolution
            self.videoResolution = configService.getClientValue('videoResolution') || 'hires-16:9';

            // video resolution for screen share.
            self.videoResolutionScreen = [self.maxScreenWidth, self.maxScreenHeight];
            var videoResolutionScreen = configService.getClientValue('videoResolutionScreen') || null;
            if (videoResolutionScreen !== null && videoResolutionScreen != 'native') {
                var match1 = videoResolutionScreen.match(/^(\d+)x(\d+)$/);
                if (match1) {
                    self.videoResolutionScreen = [parseInt(match1[1]), parseInt(match1[2])];
                } else {
                    logService.log(
                        'videoroomCtrl ignoring invalid videoResolutionScreen value ' + videoResolutionScreen
                    );
                }
            } else if (videoResolutionScreen == 'native') {
                self.videoResolutionScreen = null;
            }
            // video resolution for file play.
            self.videoResolutionFile = [self.maxFileWidth, self.maxFileHeight];
            var videoResolutionFile = configService.getClientValue('videoResolutionFile') || null;
            if (videoResolutionFile !== null && videoResolutionFile != 'native') {
                var match2 = videoResolutionFile.match(/^(\d+)x(\d+)$/);
                if (match2) {
                    self.videoResolutionFile = [parseInt(match2[1]), parseInt(match2[2])];
                } else {
                    logService.log('videoroomCtrl ignoring invalid videoResolutionFile value ' + videoResolutionFile);
                }
            } else if (videoResolutionFile == 'native') {
                self.videoResolutionFile = null;
            }

            self.enablePortraitRecord = configService.getValue('enablePortraitRecord') === 'true';

            self.initMaxVideosSize();
        }

        function initMaxVideosSize() {
            // maxVideosSize
            var maxVideosSize = configService.getValue('maxVideosSize') || '2560x1440';
            self.maxVideosSize = null;
            if (maxVideosSize && !helperService.isVideoRoomApplication()) {
                if (maxVideosSize === 'true') {
                    maxVideosSize = '2560x1440';
                }
                var match3 = maxVideosSize.match(/^(\d+)x(\d+)$/);
                if (match3) {
                    self.maxVideosSize = [parseInt(match3[1]), parseInt(match3[2])];
                } else {
                    logService.log('videoroomCtrl ignoring invalid maxVideosSize value ' + maxVideosSize);
                }
            }

            if (self.maxVideosSize && !helperService.isVideoRoomApplication()) {
                $window.$('#videoroom').attr('max-size', self.maxVideosSize[0] + 'x' + self.maxVideosSize[1]);
                $window.$('#videoroom-videos').css('max-width', self.maxVideosSize[0] + 'px');
                $window.$('#videoroom-videos').css('max-height', self.maxVideosSize[1] + 'px');
            } else {
                $window.$('#videoroom').removeAttr('max-size');
                $window.$('#videoroom-videos').css('max-width', '');
                $window.$('#videoroom-videos').css('max-height', '');
            }
        }

        // recalculate orientation attribute based on video width and height, and update layout if changed.
        function recalculateVideoOrientation(div, video) {
            var oldValue = div.getAttribute('orientation') || 'landscape'; // missing value is landscape
            let newValue;

            if (
                helperService.getVDIRef().getVdiType() !== executionEnvironmentEnum.Citrix &&
                helperService.getVDIRef().getVdiType() !== executionEnvironmentEnum.VMware
            ) {
                newValue = video.videoWidth / video.videoHeight >= 1 ? 'landscape' : 'portrait';
            } else {
                newValue = video.videoWidth / video.videoHeight >= 1 ? 'portrait' : 'landscape';
            }
            if (oldValue != newValue) {
                if (newValue == 'landscape') {
                    div.removeAttribute('orientation');
                } else {
                    div.setAttribute('orientation', newValue);
                }
                self.updateVideosLayout();
            }
        }

        // when video element is resized, update the orientation property, and if
        // changed then update the layout.
        function onVideoResize(event) {
            var video = event.currentTarget;
            var div = video.parentNode;
            if (div && !div.remoteFeed) {
                // for local video, limit number of logs of resize. TODO: refactor to make it generic.
                div.videoResizeCount = (div.videoResizeCount || 0) + 1;
                var now = Date.now();
                if (!div.videoResizeLast || now - div.videoResizeLast >= 30000) {
                    // once per 30 seconds
                    logService.log(
                        'videoroomCtrl video resize event ' +
                            video.videoWidth +
                            'x' +
                            video.videoHeight +
                            ' (count=' +
                            div.videoResizeCount +
                            ')'
                    );
                    div.videoResizeLast = now;
                    div.videoResizeCount = 0;
                }
            } else {
                self.logLayout('videoroomCtrl video resize event ' + video.videoWidth + 'x' + video.videoHeight);
            }

            if (div && video.videoWidth && video.videoHeight) {
                self.recalculateVideoOrientation(div, video);

                // update video background to black for spotlight screen video under certain conditions.
                if (div == self.maxvideo && $window.$(div).hasClass('screen')) {
                    self.applyBlackBgToMaxScreenIfNeeded();
                }
            }
        }

        // remove device and camera orientation changed. treat it as if resize event was received.
        // not applicable for screen video.
        function onVideoOrientationChange(id) {
            var div = $window.$('#videoroom-videos div[user="' + id + '"]')[0];
            var video = div ? div.querySelector('video') : null;
            if (div && video && video.videoWidth && video.videoHeight) {
                logService.log('videoroomCtrl video orientationchange ' + video.videoWidth + 'x' + video.videoHeight);
                self.recalculateVideoOrientation(div, video);
            }
        }

        function getVideoResolution() {
            var width = self.idealVideoWidth,
                height = self.idealVideoHeight;
            if (self.videoResolution == 'lowres') {
                width = 320;
                height = 240;
            } else if (self.videoResolution == 'lowres-16:9') {
                width = 320;
                height = 180;
            } else if (self.videoResolution == 'stdres') {
                width = 640;
                height = 480;
            } else if (self.videoResolution == 'stdres-16:9') {
                width = 640;
                height = 360;
            } else {
                var match = self.videoResolution && self.videoResolution.match(/^(\d+)x(\d+)$/);
                if (match) {
                    width = parseInt(match[1]);
                    height = parseInt(match[2]);
                    if (!width && height) {
                        width = Math.round(height * self.idealAspectRatio);
                    } else if (width && !height) {
                        height = Math.round(width / self.idealAspectRatio);
                    }
                }
            }

            return { width: width, height: height };
        }
    }
]);
